module.exports = __webpack_public_path__ + "img/before9.407db00a.png";